/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prop-types */
import { resolve } from 'path';
import React, { createContext, useState } from 'react';

export const CarrinhoContext = createContext({});

export const CarrinhoProvider = ({ children }) => {
  const [produtoCar, setProdutoCar] = useState([]);
  const [clienteCar, setCliente] = useState({});

  const addClienteCar = (cliente) => {
    setCliente(cliente);
  };
  const addProdutoCar = (produto) => {
    return new Promise((resolve, reject) => {
      setProdutoCar((produtoCar) => [...produtoCar, produto]);
      resolve(produto);
    });
  };

  const removeProdutoCar = async (itemIndex) => {
    const filtro = produtoCar.filter((elem, index) => index !== itemIndex);
    clearProdutoCar();
    return new Promise((resolve) => setTimeout(() => resolve(setProdutoCar(filtro)), 250));
  };

  const clearProdutoCar = () => {
    setProdutoCar([]);
  };

  return (
    <CarrinhoContext.Provider
      value={{
        produtoCar,
        addProdutoCar,
        removeProdutoCar,
        clearProdutoCar,
        addClienteCar,
        clienteCar,
      }}
    >
      {children}
    </CarrinhoContext.Provider>
  );
};
